import React, { useState, useCallback } from 'react';
import ReactTooltip from 'react-tooltip';
import useWindowSize from '@Hooks/useWindowSize';
import styled from 'styled-components';

const TrimTittle = styled.div({
    opacity: 0.4,
    fontSize: '1.2rem',
    '&:hover': {
        opacity: 1
    }
});

const OFFSET_RIGHT_WIDTH = 70;
const FRACTION_WIDTH = 4 / 5;

export function LongTrimmedTitle({ title, offsetWidth = OFFSET_RIGHT_WIDTH, ...rest }) {
    const [trimmedTitle, setTrimmedTitle] = useState(title);

    const size = useWindowSize();
    const MAX_WIDTH = size.width * FRACTION_WIDTH - offsetWidth;
    const elRef = useCallback(
        node => {
            if (node !== null) {
                if (title && size.width && node.clientWidth && node.clientWidth > MAX_WIDTH) {
                    let allowedCharsCount = Math.floor((size.width * 0.1) / 2);

                    setTrimmedTitle(
                        title.substr(0, allowedCharsCount) +
                            '...' +
                            title.substr(title.length - allowedCharsCount, title.length)
                    );
                } else if (node.clientWidth && size.width) {
                    setTrimmedTitle(title);
                }
            }
        },
        [size.width]
    );

    return (
        <>
            <div data-tip={title != trimmedTitle ? title : ''} data-for={`clause-title`} {...rest}>
                <TrimTittle>{trimmedTitle}</TrimTittle>
            </div>

            <ReactTooltip
                id={`clause-title`}
                effect="solid"
                multiline
                place="bottom"
                className="title-clause-tooltip"
            />

            <div
                style={{
                    position: 'absolute',
                    visibility: 'hidden',
                    height: 'auto',
                    width: 'auto',
                    whiteSpace: 'nowrap'
                }}
                ref={elRef}
            >
                {title}
            </div>
        </>
    );
}
